if (!customElements.get('product-card-sku')) {
  class ProductCardSku extends HTMLElement {
    connectedCallback() {
      this.target = this.querySelector('[data-product-sku]');
      this.card = this.closest('product-card');

      if (!this.target || !this.card) return;

      this.defaultSku = this.target.dataset.defaultSku || '';
      this.styleNumber = this.target.dataset.styleNumber || '';

      this.sync = this.sync.bind(this);
      this.queue = () => {
        clearTimeout(this._t);
        this._t = setTimeout(this.sync, 50);
      };

      this.card.addEventListener('change', this.queue);
      this.sync();
    }

    disconnectedCallback() {
      clearTimeout(this._t);
      this.card?.removeEventListener('change', this.queue);
    }

    activePicker() {
      const pickers = [...this.card.querySelectorAll('swatches-variant-picker')];

      if (!pickers.length) return null;

      return (
        pickers.find((p) => p.offsetParent !== null) ||
        pickers.find((p) => p.querySelector('input[type="radio"]:checked')) ||
        pickers[0]
      );
    }

    variants(picker) {
      const el = picker.querySelector('[data-variants-cache]');

      if (!el) return null;

      if (!el._parsed) {
        try {
          el._parsed = JSON.parse(el.textContent).variants || [];
        } catch (e) {
          el._parsed = [];
        }
      }

      return el._parsed;
    }

    resolveSku() {
      const picker = this.activePicker();

      if (!picker) return this.defaultSku;

      const checked = [
        ...picker.querySelectorAll('input[type="radio"]:checked')
      ];

      if (!checked.length) return this.defaultSku;

      const variants = this.variants(picker);

      if (!variants || !variants.length) {
        return this.defaultSku;
      }

      const selected = {};

      for (const input of checked) {
        const position = (input.dataset.inputId || '').split('-')[0];

        if (position) {
          selected[position] = input.value;
        }
      }

      const matches = variants.filter((v) =>
        Object.keys(selected).every(
          (pos) => v['option' + pos] === selected[pos]
        )
      );

      if (!matches.length) return this.defaultSku;

      const variant = matches.find((v) => v.available) || matches[0];

      return variant.sku || '';
    }

    sync() {
      // If Style Number exists, always display Style Number.
      if (this.styleNumber) {
        if (this.target.textContent.trim() !== this.styleNumber) {
          this.target.textContent = this.styleNumber;
        }

        this.target.hidden = false;
        return;
      }

      // Otherwise display the selected variant SKU.
      const sku = this.resolveSku();

      if (this.target.textContent.trim() === sku) return;

      this.target.textContent = sku;
      this.target.hidden = !sku;
    }
  }

  customElements.define('product-card-sku', ProductCardSku);
}